import KeywordListMenu from './KeywordListMenu.vue';

export default KeywordListMenu;
